import { useQuery } from 'react-query';

import { MiscFlowTypesResponse } from './api/types';
import { fetchMiscFlowTypes } from './api/misc-flow-types';

export const useMiscFlowTypes = () => {
    console.log('useMiscFlowTypes hook called'); // Debug log
    const result = useQuery<MiscFlowTypesResponse, Error>(
        ['miscFlowTypes'],
        async () => {
            console.log('React Query is executing fetchMiscFlowTypes');
            return await fetchMiscFlowTypes();
        },
        {
            staleTime: 5 * 60 * 1000,
            cacheTime: 10 * 60 * 1000,
            enabled: true, // Force enabled
            retry: 1,
            onError: (error) => {
                console.error('miscFlowTypes API error:', error);
            },
        }
    );
    console.log('useMiscFlowTypes result:', result.status, result.data, result.error);
    return result;
};
